import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/parties';

const namespace = 'PARTIES';

/* Parties Actions */

export const FETCH_PARTY_TYPES_START = `${namespace}/FETCH_PARTY_TYPES_START`;
export const FETCH_PARTY_TYPES_SUCCESS = `${namespace}/FETCH_PARTY_TYPES_SUCCESS`;
export const FETCH_PARTY_TYPES_ERROR = `${namespace}/FETCH_PARTY_TYPES_ERROR`;

export const fetchPartyTypes = makeApiActionCreatorV3(
  api.fetchPartyTypes,
  FETCH_PARTY_TYPES_START,
  FETCH_PARTY_TYPES_SUCCESS,
  FETCH_PARTY_TYPES_ERROR,
);

export const FETCH_AGENT_AUTHS_START = `${namespace}/FETCH_AGENT_AUTHS_START`;
export const FETCH_AGENT_AUTHS_SUCCESS = `${namespace}/FETCH_AGENT_AUTHS_SUCCESS`;
export const FETCH_AGENT_AUTHS_ERROR = `${namespace}/FETCH_AGENT_AUTHS_ERROR`;

export const fetchAgentAuths = makeApiActionCreatorV3(
  api.fetchAgentAuths,
  FETCH_AGENT_AUTHS_START,
  FETCH_AGENT_AUTHS_SUCCESS,
  FETCH_AGENT_AUTHS_ERROR,
);

export const FETCH_PARTIES_START = `${namespace}/FETCH_PARTIES_START`;
export const FETCH_PARTIES_SUCCESS = `${namespace}/FETCH_PARTIES_SUCCESS`;
export const FETCH_PARTIES_ERROR = `${namespace}/FETCH_PARTIES_ERROR`;

export const fetchParties = makeApiActionCreatorV3(
  api.fetchParties,
  FETCH_PARTIES_START,
  FETCH_PARTIES_SUCCESS,
  FETCH_PARTIES_ERROR,
);

export const FETCH_PARTY_START = `${namespace}/FETCH_PARTY_START`;
export const FETCH_PARTY_SUCCESS = `${namespace}/FETCH_PARTY_SUCCESS`;
export const FETCH_PARTY_ERROR = `${namespace}/FETCH_PARTY_ERROR`;

export const fetchParty = makeApiActionCreatorV3(
  api.fetchParty,
  FETCH_PARTY_START,
  FETCH_PARTY_SUCCESS,
  FETCH_PARTY_ERROR,
);

export const INSERT_PARTY_START = `${namespace}/INSERT_PARTY_START`;
export const INSERT_PARTY_SUCCESS = `${namespace}/INSERT_PARTY_SUCCESS`;
export const INSERT_PARTY_ERROR = `${namespace}/INSERT_PARTY_ERROR`;

export const insertParty = makeApiActionCreatorV3(
  api.insertParty,
  INSERT_PARTY_START,
  INSERT_PARTY_SUCCESS,
  INSERT_PARTY_ERROR,
);

export const UPDATE_PARTY_START = `${namespace}/UPDATE_PARTY_START`;
export const UPDATE_PARTY_SUCCESS = `${namespace}/UPDATE_PARTY_SUCCESS`;
export const UPDATE_PARTY_ERROR = `${namespace}/UPDATE_PARTY_ERROR`;

export const updateParty = makeApiActionCreatorV3(
  api.updateParty,
  UPDATE_PARTY_START,
  UPDATE_PARTY_SUCCESS,
  UPDATE_PARTY_ERROR,
);

export const DELETE_PARTY_START = `${namespace}/DELETE_PARTY_START`;
export const DELETE_PARTY_SUCCESS = `${namespace}/DELETE_PARTY_SUCCESS`;
export const DELETE_PARTY_ERROR = `${namespace}/DELETE_PARTY_ERROR`;

export const deleteParty = makeApiActionCreatorV3(
  api.deleteParty,
  DELETE_PARTY_START,
  DELETE_PARTY_SUCCESS,
  DELETE_PARTY_ERROR,
);

export const FETCH_PARTY_FILES_START = `${namespace}/FETCH_PARTY_FILES_START`;
export const FETCH_PARTY_FILES_SUCCESS = `${namespace}/FETCH_PARTY_FILES_SUCCESS`;
export const FETCH_PARTY_FILES_ERROR = `${namespace}/FETCH_PARTY_FILES_ERROR`;

export const fetchPartyFiles = makeApiActionCreatorV3(
  api.fetchPartyFiles,
  FETCH_PARTY_FILES_START,
  FETCH_PARTY_FILES_SUCCESS,
  FETCH_PARTY_FILES_ERROR,
);

export const FETCH_PARTY_FILE_START = `${namespace}/FETCH_PARTY_FILE_START`;
export const FETCH_PARTY_FILE_SUCCESS = `${namespace}/FETCH_PARTY_FILE_SUCCESS`;
export const FETCH_PARTY_FILE_ERROR = `${namespace}/FETCH_PARTY_FILE_ERROR`;

export const fetchPartyFile = makeApiActionCreatorV3(
  api.fetchPartyFile,
  FETCH_PARTY_FILE_START,
  FETCH_PARTY_FILE_SUCCESS,
  FETCH_PARTY_FILE_ERROR,
);

export const FETCH_PARTY_CASES_START = `${namespace}/FETCH_PARTY_CASES_START`;
export const FETCH_PARTY_CASES_SUCCESS = `${namespace}/FETCH_PARTY_CASES_SUCCESS`;
export const FETCH_PARTY_CASES_ERROR = `${namespace}/FETCH_PARTY_CASES_ERROR`;

export const fetchPartyCases = makeApiActionCreatorV3(
  api.fetchPartyCases,
  FETCH_PARTY_CASES_START,
  FETCH_PARTY_CASES_SUCCESS,
  FETCH_PARTY_CASES_ERROR,
);

export const INSERT_PARTY_FILE_START = `${namespace}/INSERT_PARTY_FILE_START`;
export const INSERT_PARTY_FILE_SUCCESS = `${namespace}/INSERT_PARTY_FILE_SUCCESS`;
export const INSERT_PARTY_FILE_ERROR = `${namespace}/INSERT_PARTY_FILE_ERROR`;

export const insertPartyFile = makeApiActionCreatorV3(
  api.insertPartyFile,
  INSERT_PARTY_FILE_START,
  INSERT_PARTY_FILE_SUCCESS,
  INSERT_PARTY_FILE_ERROR,
);

export const DELETE_PARTY_FILE_START = `${namespace}/DELETE_PARTY_FILE_START`;
export const DELETE_PARTY_FILE_SUCCESS = `${namespace}/DELETE_PARTY_FILE_SUCCESS`;
export const DELETE_PARTY_FILE_ERROR = `${namespace}/DELETE_PARTY_FILE_ERROR`;

export const deletePartyFile = makeApiActionCreatorV3(
  api.deletePartyFile,
  DELETE_PARTY_FILE_START,
  DELETE_PARTY_FILE_SUCCESS,
  DELETE_PARTY_FILE_ERROR,
);

export const DOWNLOAD_PARTY_FILE_START = `${namespace}/DOWNLOAD_PARTY_FILE_START`;
export const DOWNLOAD_PARTY_FILE_SUCCESS = `${namespace}/DOWNLOAD_PARTY_FILE_SUCCESS`;
export const DOWNLOAD_PARTY_FILE_ERROR = `${namespace}/DOWNLOAD_PARTY_FILE_ERROR`;

export const downloadPartyFile = makeApiActionCreatorV3(
  api.downloadPartyFile,
  DOWNLOAD_PARTY_FILE_START,
  DOWNLOAD_PARTY_FILE_SUCCESS,
  DOWNLOAD_PARTY_FILE_ERROR,
);

export const SET_CURRENT_PARTY = `${namespace}/SET_CURRENT_PARTY`;

export const setCurrentParty = (party) => ({
  type: SET_CURRENT_PARTY,
  payload: party,
});

/* CAD Parties Actions */

export const FETCH_CAD_PARTIES_START = `${namespace}/FETCH_CAD_PARTIES_START`;
export const FETCH_CAD_PARTIES_SUCCESS = `${namespace}/FETCH_CAD_PARTIES_SUCCESS`;
export const FETCH_CAD_PARTIES_ERROR = `${namespace}/FETCH_CAD_PARTIES_ERROR`;

export const fetchCadParties = makeApiActionCreatorV3(
  api.fetchCadParties,
  FETCH_CAD_PARTIES_START,
  FETCH_CAD_PARTIES_SUCCESS,
  FETCH_CAD_PARTIES_ERROR,
);

export const FETCH_CAD_PARTY_START = `${namespace}/FETCH_CAD_PARTY_START`;
export const FETCH_CAD_PARTY_SUCCESS = `${namespace}/FETCH_CAD_PARTY_SUCCESS`;
export const FETCH_CAD_PARTY_ERROR = `${namespace}/FETCH_CAD_PARTY_ERROR`;

export const fetchCadParty = makeApiActionCreatorV3(
  api.fetchCadParty,
  FETCH_CAD_PARTY_START,
  FETCH_CAD_PARTY_SUCCESS,
  FETCH_CAD_PARTY_ERROR,
);

export const INSERT_CAD_PARTY_START = `${namespace}/INSERT_CAD_PARTY_START`;
export const INSERT_CAD_PARTY_SUCCESS = `${namespace}/INSERT_CAD_PARTY_SUCCESS`;
export const INSERT_CAD_PARTY_ERROR = `${namespace}/INSERT_CAD_PARTY_ERROR`;

export const insertCadParty = makeApiActionCreatorV3(
  api.insertCadParty,
  INSERT_CAD_PARTY_START,
  INSERT_CAD_PARTY_SUCCESS,
  INSERT_CAD_PARTY_ERROR,
);

export const UPDATE_CAD_PARTY_START = `${namespace}/UPDATE_CAD_PARTY_START`;
export const UPDATE_CAD_PARTY_SUCCESS = `${namespace}/UPDATE_CAD_PARTY_SUCCESS`;
export const UPDATE_CAD_PARTY_ERROR = `${namespace}/UPDATE_CAD_PARTY_ERROR`;

export const updateCadParty = makeApiActionCreatorV3(
  api.updateCadParty,
  UPDATE_CAD_PARTY_START,
  UPDATE_CAD_PARTY_SUCCESS,
  UPDATE_CAD_PARTY_ERROR,
);

export const ACTIVATE_CAD_PARTY_START = `${namespace}/ACTIVATE_CAD_PARTY_START`;
export const ACTIVATE_CAD_PARTY_SUCCESS = `${namespace}/ACTIVATE_CAD_PARTY_SUCCESS`;
export const ACTIVATE_CAD_PARTY_ERROR = `${namespace}/ACTIVATE_CAD_PARTY_ERROR`;

export const activateCadParty = makeApiActionCreatorV3(
  api.activateCadParty,
  ACTIVATE_CAD_PARTY_START,
  ACTIVATE_CAD_PARTY_SUCCESS,
  ACTIVATE_CAD_PARTY_ERROR,
);

export const DEACTIVATE_CAD_PARTY_START = `${namespace}/DEACTIVATE_CAD_PARTY_START`;
export const DEACTIVATE_CAD_PARTY_SUCCESS = `${namespace}/DEACTIVATE_CAD_PARTY_SUCCESS`;
export const DEACTIVATE_CAD_PARTY_ERROR = `${namespace}/DEACTIVATE_CAD_PARTY_ERROR`;

export const deactivateCadParty = makeApiActionCreatorV3(
  api.deactivateCadParty,
  DEACTIVATE_CAD_PARTY_START,
  DEACTIVATE_CAD_PARTY_SUCCESS,
  DEACTIVATE_CAD_PARTY_ERROR,
);

export const DELETE_CAD_PARTY_START = `${namespace}/DELETE_CAD_PARTY_START`;
export const DELETE_CAD_PARTY_SUCCESS = `${namespace}/DELETE_CAD_PARTY_SUCCESS`;
export const DELETE_CAD_PARTY_ERROR = `${namespace}/DELETE_CAD_PARTY_ERROR`;

export const deleteCadParty = makeApiActionCreatorV3(
  api.deleteCadParty,
  DELETE_CAD_PARTY_START,
  DELETE_CAD_PARTY_SUCCESS,
  DELETE_CAD_PARTY_ERROR,
);

/* CAD Party Associations Actions */

export const FETCH_CAD_PARTY_ASSOCIATIONS_START = `${namespace}/FETCH_CAD_PARTY_ASSOCIATIONS_START`;
export const FETCH_CAD_PARTY_ASSOCIATIONS_SUCCESS = `${namespace}/FETCH_CAD_PARTY_ASSOCIATIONS_SUCCESS`;
export const FETCH_CAD_PARTY_ASSOCIATIONS_ERROR = `${namespace}/FETCH_CAD_PARTY_ASSOCIATIONS_ERROR`;

export const fetchCadPartyAssociations = makeApiActionCreatorV3(
  api.fetchCadPartyAssociations,
  FETCH_CAD_PARTY_ASSOCIATIONS_START,
  FETCH_CAD_PARTY_ASSOCIATIONS_SUCCESS,
  FETCH_CAD_PARTY_ASSOCIATIONS_ERROR,
);

export const FETCH_CAD_PARTY_ASSOCIATION_START = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_START`;
export const FETCH_CAD_PARTY_ASSOCIATION_SUCCESS = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_SUCCESS`;
export const FETCH_CAD_PARTY_ASSOCIATION_ERROR = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_ERROR`;

export const fetchCadPartyAssociation = makeApiActionCreatorV3(
  api.fetchCadPartyAssociation,
  FETCH_CAD_PARTY_ASSOCIATION_START,
  FETCH_CAD_PARTY_ASSOCIATION_SUCCESS,
  FETCH_CAD_PARTY_ASSOCIATION_ERROR,
);

export const FETCH_CAD_PARTY_ASSOCIATION_FILES_START = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILES_START`;
export const FETCH_CAD_PARTY_ASSOCIATION_FILES_SUCCESS = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILES_SUCCESS`;
export const FETCH_CAD_PARTY_ASSOCIATION_FILES_ERROR = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILES_ERROR`;

export const fetchCadPartyAssociationFiles = makeApiActionCreatorV3(
  api.fetchCadPartyAssociationFiles,
  FETCH_CAD_PARTY_ASSOCIATION_FILES_START,
  FETCH_CAD_PARTY_ASSOCIATION_FILES_SUCCESS,
  FETCH_CAD_PARTY_ASSOCIATION_FILES_ERROR,
);

export const FETCH_CAD_PARTY_ASSOCIATION_FILE_START = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILE_START`;
export const FETCH_CAD_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const FETCH_CAD_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/FETCH_CAD_PARTY_ASSOCIATION_FILE_ERROR`;

export const fetchCadPartyAssociationFile = makeApiActionCreatorV3(
  api.fetchCadPartyAssociationFile,
  FETCH_CAD_PARTY_ASSOCIATION_FILE_START,
  FETCH_CAD_PARTY_ASSOCIATION_FILE_SUCCESS,
  FETCH_CAD_PARTY_ASSOCIATION_FILE_ERROR,
);

export const INSERT_CAD_PARTY_ASSOCIATION_START = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_START`;
export const INSERT_CAD_PARTY_ASSOCIATION_SUCCESS = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_SUCCESS`;
export const INSERT_CAD_PARTY_ASSOCIATION_ERROR = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_ERROR`;

export const insertCadPartyAssociation = makeApiActionCreatorV3(
  api.insertCadPartyAssociation,
  INSERT_CAD_PARTY_ASSOCIATION_START,
  INSERT_CAD_PARTY_ASSOCIATION_SUCCESS,
  INSERT_CAD_PARTY_ASSOCIATION_ERROR,
);

export const INSERT_CAD_PARTY_ASSOCIATION_FILE_START = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_FILE_START`;
export const INSERT_CAD_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const INSERT_CAD_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/INSERT_CAD_PARTY_ASSOCIATION_FILE_ERROR`;

export const insertCadPartyAssociationFile = makeApiActionCreatorV3(
  api.insertCadPartyAssociationFile,
  INSERT_CAD_PARTY_ASSOCIATION_FILE_START,
  INSERT_CAD_PARTY_ASSOCIATION_FILE_SUCCESS,
  INSERT_CAD_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DELETE_CAD_PARTY_ASSOCIATION_START = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_START`;
export const DELETE_CAD_PARTY_ASSOCIATION_SUCCESS = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_SUCCESS`;
export const DELETE_CAD_PARTY_ASSOCIATION_ERROR = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_ERROR`;

export const deleteCadPartyAssociation = makeApiActionCreatorV3(
  api.deleteCadPartyAssociation,
  DELETE_CAD_PARTY_ASSOCIATION_START,
  DELETE_CAD_PARTY_ASSOCIATION_SUCCESS,
  DELETE_CAD_PARTY_ASSOCIATION_ERROR,
);

export const DELETE_CAD_PARTY_ASSOCIATION_FILE_START = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_FILE_START`;
export const DELETE_CAD_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const DELETE_CAD_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/DELETE_CAD_PARTY_ASSOCIATION_FILE_ERROR`;

export const deleteCadPartyAssociationFile = makeApiActionCreatorV3(
  api.deleteCadPartyAssociationFile,
  DELETE_CAD_PARTY_ASSOCIATION_FILE_START,
  DELETE_CAD_PARTY_ASSOCIATION_FILE_SUCCESS,
  DELETE_CAD_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DOWNLOAD_CAD_PARTY_FILE_START = `${namespace}/DOWNLOAD_CAD_PARTY_FILE_START`;
export const DOWNLOAD_CAD_PARTY_FILE_SUCCESS = `${namespace}/DOWNLOAD_CAD_PARTY_FILE_SUCCESS`;
export const DOWNLOAD_CAD_PARTY_FILE_ERROR = `${namespace}/DOWNLOAD_CAD_PARTY_FILE_ERROR`;

export const downloadCadPartyFile = makeApiActionCreatorV3(
  api.downloadCadPartyFile,
  DOWNLOAD_CAD_PARTY_FILE_START,
  DOWNLOAD_CAD_PARTY_FILE_SUCCESS,
  DOWNLOAD_CAD_PARTY_FILE_ERROR,
);

export const DOWNLOAD_CAD_PARTY_ASSOC_FILE_START = `${namespace}/DOWNLOAD_CAD_PARTY_ASSOC_FILE_START`;
export const DOWNLOAD_CAD_PARTY_ASSOC_FILE_SUCCESS = `${namespace}/DOWNLOAD_CAD_PARTY_ASSOC_FILE_SUCCESS`;
export const DOWNLOAD_CAD_PARTY_ASSOC_FILE_ERROR = `${namespace}/DOWNLOAD_CAD_PARTY_ASSOC_FILE_ERROR`;

export const downloadCadPartyAssociationFile = makeApiActionCreatorV3(
  api.downloadCadPartyAssociationFile,
  DOWNLOAD_CAD_PARTY_ASSOC_FILE_START,
  DOWNLOAD_CAD_PARTY_ASSOC_FILE_SUCCESS,
  DOWNLOAD_CAD_PARTY_ASSOC_FILE_ERROR,
);

export const SET_APPRAISER_PARTY_PRIMARY_START = `${namespace}/SET_APPRAISER_PARTY_PRIMARY_START`;
export const SET_APPRAISER_PARTY_PRIMARY_SUCCESS = `${namespace}/SET_APPRAISER_PARTY_PRIMARY_SUCCESS`;
export const SET_APPRAISER_PARTY_PRIMARY_ERROR = `${namespace}/SET_APPRAISER_PARTY_PRIMARY_ERROR`;

export const setAppraiserPartyPrimary = makeApiActionCreatorV3(
  api.setAppraiserPartyPrimary,
  SET_APPRAISER_PARTY_PRIMARY_START,
  SET_APPRAISER_PARTY_PRIMARY_SUCCESS,
  SET_APPRAISER_PARTY_PRIMARY_ERROR,
);

export const SET_CAD_PARTY_PRIMARY_START = `${namespace}/SET_CAD_PARTY_PRIMARY_START`;
export const SET_CAD_PARTY_PRIMARY_SUCCESS = `${namespace}/SET_CAD_PARTY_PRIMARY_SUCCESS`;
export const SET_CAD_PARTY_PRIMARY_ERROR = `${namespace}/SET_CAD_PARTY_PRIMARY_ERROR`;

export const setCadPartyPrimary = makeApiActionCreatorV3(
  api.setCadPartyPrimary,
  SET_CAD_PARTY_PRIMARY_START,
  SET_CAD_PARTY_PRIMARY_SUCCESS,
  SET_CAD_PARTY_PRIMARY_ERROR,
);

/* Plaintiff Party Actions */

export const FETCH_PLAINTIFF_PARTIES_START = `${namespace}/FETCH_PLAINTIFF_PARTIES_START`;
export const FETCH_PLAINTIFF_PARTIES_SUCCESS = `${namespace}/FETCH_PLAINTIFF_PARTIES_SUCCESS`;
export const FETCH_PLAINTIFF_PARTIES_ERROR = `${namespace}/FETCH_PLAINTIFF_PARTIES_ERROR`;

export const fetchPlaintiffParties = makeApiActionCreatorV3(
  api.fetchPlaintiffParties,
  FETCH_PLAINTIFF_PARTIES_START,
  FETCH_PLAINTIFF_PARTIES_SUCCESS,
  FETCH_PLAINTIFF_PARTIES_ERROR,
);

export const INSERT_PLAINTIFF_PARTY_START = `${namespace}/INSERT_PLAINTIFF_PARTY_START`;
export const INSERT_PLAINTIFF_PARTY_SUCCESS = `${namespace}/INSERT_PLAINTIFF_PARTY_SUCCESS`;
export const INSERT_PLAINTIFF_PARTY_ERROR = `${namespace}/INSERT_PLAINTIFF_PARTY_ERROR`;

export const insertPlaintiffParty = makeApiActionCreatorV3(
  api.insertPlaintiffParty,
  INSERT_PLAINTIFF_PARTY_START,
  INSERT_PLAINTIFF_PARTY_SUCCESS,
  INSERT_PLAINTIFF_PARTY_ERROR,
);

export const UPDATE_PLAINTIFF_PARTY_START = `${namespace}/UPDATE_PLAINTIFF_PARTY_START`;
export const UPDATE_PLAINTIFF_PARTY_SUCCESS = `${namespace}/UPDATE_PLAINTIFF_PARTY_SUCCESS`;
export const UPDATE_PLAINTIFF_PARTY_ERROR = `${namespace}/UPDATE_PLAINTIFF_PARTY_ERROR`;

export const updatePlaintiffParty = makeApiActionCreatorV3(
  api.updatePlaintiffParty,
  UPDATE_PLAINTIFF_PARTY_START,
  UPDATE_PLAINTIFF_PARTY_SUCCESS,
  UPDATE_PLAINTIFF_PARTY_ERROR,
);

export const UPDATE_PLAINTIFF_PARTY_PHONE_START = `${namespace}/UPDATE_PLAINTIFF_PARTY_PHONE_START`;
export const UPDATE_PLAINTIFF_PARTY_PHONE_SUCCESS = `${namespace}/UPDATE_PLAINTIFF_PARTY_PHONE_SUCCESS`;
export const UPDATE_PLAINTIFF_PARTY_PHONE_ERROR = `${namespace}/UPDATE_PLAINTIFF_PARTY_PHONE_ERROR`;

export const updatePlaintiffPartyPhone = makeApiActionCreatorV3(
  api.updatePlaintiffPartyPhone,
  UPDATE_PLAINTIFF_PARTY_PHONE_START,
  UPDATE_PLAINTIFF_PARTY_PHONE_SUCCESS,
  UPDATE_PLAINTIFF_PARTY_PHONE_ERROR,
);

export const DELETE_PLAINTIFF_PARTY_START = `${namespace}/DELETE_PLAINTIFF_PARTY_START`;
export const DELETE_PLAINTIFF_PARTY_SUCCESS = `${namespace}/DELETE_PLAINTIFF_PARTY_SUCCESS`;
export const DELETE_PLAINTIFF_PARTY_ERROR = `${namespace}/DELETE_PLAINTIFF_PARTY_ERROR`;

export const deletePlaintiffParty = makeApiActionCreatorV3(
  api.deletePlaintiffParty,
  DELETE_PLAINTIFF_PARTY_START,
  DELETE_PLAINTIFF_PARTY_SUCCESS,
  DELETE_PLAINTIFF_PARTY_ERROR,
);

export const ACTIVATE_PLAINTIFF_PARTY_START = `${namespace}/ACTIVATE_PLAINTIFF_PARTY_START`;
export const ACTIVATE_PLAINTIFF_PARTY_SUCCESS = `${namespace}/ACTIVATE_PLAINTIFF_PARTY_SUCCESS`;
export const ACTIVATE_PLAINTIFF_PARTY_ERROR = `${namespace}/ACTIVATE_PLAINTIFF_PARTY_ERROR`;

export const activatePlaintiffParty = makeApiActionCreatorV3(
  api.activatePlaintiffParty,
  ACTIVATE_PLAINTIFF_PARTY_START,
  ACTIVATE_PLAINTIFF_PARTY_SUCCESS,
  ACTIVATE_PLAINTIFF_PARTY_ERROR,
);

export const DEACTIVATE_PLAINTIFF_PARTY_START = `${namespace}/DEACTIVATE_PLAINTIFF_PARTY_START`;
export const DEACTIVATE_PLAINTIFF_PARTY_SUCCESS = `${namespace}/DEACTIVATE_PLAINTIFF_PARTY_SUCCESS`;
export const DEACTIVATE_PLAINTIFF_PARTY_ERROR = `${namespace}/DEACTIVATE_PLAINTIFF_PARTY_ERROR`;

export const deactivatePlaintiffParty = makeApiActionCreatorV3(
  api.deactivatePlaintiffParty,
  DEACTIVATE_PLAINTIFF_PARTY_START,
  DEACTIVATE_PLAINTIFF_PARTY_SUCCESS,
  DEACTIVATE_PLAINTIFF_PARTY_ERROR,
);

/* Plaintiff Party Associations Actions */

export const FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_START = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_START`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_SUCCESS = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_SUCCESS`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_ERROR = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_ERROR`;

export const fetchPlaintiffPartyAssociations = makeApiActionCreatorV3(
  api.fetchPlaintiffPartyAssociations,
  FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_START,
  FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_SUCCESS,
  FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_ERROR,
);

export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_START = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_START`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_ERROR = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_ERROR`;

export const fetchPlaintiffPartyAssociation = makeApiActionCreatorV3(
  api.fetchPlaintiffPartyAssociation,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_START,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_ERROR,
);

export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_START = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_START`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_SUCCESS = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_SUCCESS`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_ERROR = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_ERROR`;

export const fetchPlaintiffPartyAssociationFiles = makeApiActionCreatorV3(
  api.fetchPlaintiffPartyAssociationFiles,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_START,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_SUCCESS,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_ERROR,
);

export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_START = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_START`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR`;

export const fetchPlaintiffPartyAssociationFile = makeApiActionCreatorV3(
  api.fetchPlaintiffPartyAssociationFile,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_START,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS,
  FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR,
);

export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_START = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_START`;
export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS`;
export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_ERROR = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_ERROR`;

export const insertPlaintiffPartyAssociation = makeApiActionCreatorV3(
  api.insertPlaintiffPartyAssociation,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_START,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_ERROR,
);

export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_START = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_START`;
export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR`;

export const insertPlaintiffPartyAssociationFile = makeApiActionCreatorV3(
  api.insertPlaintiffPartyAssociationFile,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_START,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS,
  INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_START = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_START`;
export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS`;
export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_ERROR = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_ERROR`;

export const deletePlaintiffPartyAssociation = makeApiActionCreatorV3(
  api.deletePlaintiffPartyAssociation,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_START,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_ERROR,
);

export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_START = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_START`;
export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR`;

export const deletePlaintiffPartyAssociationFile = makeApiActionCreatorV3(
  api.deletePlaintiffPartyAssociationFile,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_START,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS,
  DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DOWNLOAD_PLAINTIFF_PARTY_FILE_START = `${namespace}/DOWNLOAD_PLAINTIFF_PARTY_FILE_START`;
export const DOWNLOAD_PLAINTIFF_PARTY_FILE_SUCCESS = `${namespace}/DOWNLOAD_PLAINTIFF_PARTY_FILE_SUCCESS`;
export const DOWNLOAD_PLAINTIFF_PARTY_FILE_ERROR = `${namespace}/DOWNLOAD_PLAINTIFF_PARTY_FILE_ERROR`;

export const downloadPlaintiffPartyFile = makeApiActionCreatorV3(
  api.downloadPlaintiffPartyFile,
  DOWNLOAD_PLAINTIFF_PARTY_FILE_START,
  DOWNLOAD_PLAINTIFF_PARTY_FILE_SUCCESS,
  DOWNLOAD_PLAINTIFF_PARTY_FILE_ERROR,
);

export const SET_PLAINTIFF_PARTY_PRIMARY_START = `${namespace}/SET_PLAINTIFF_PARTY_PRIMARY_START`;
export const SET_PLAINTIFF_PARTY_PRIMARY_SUCCESS = `${namespace}/SET_PLAINTIFF_PARTY_PRIMARY_SUCCESS`;
export const SET_PLAINTIFF_PARTY_PRIMARY_ERROR = `${namespace}/SET_PLAINTIFF_PARTY_PRIMARY_ERROR`;

export const setPlaintiffPartyPrimary = makeApiActionCreatorV3(
  api.setPlaintiffPartyPrimary,
  SET_PLAINTIFF_PARTY_PRIMARY_START,
  SET_PLAINTIFF_PARTY_PRIMARY_SUCCESS,
  SET_PLAINTIFF_PARTY_PRIMARY_ERROR,
);

/* Impartial Party Actions */

export const FETCH_IMPARTIAL_PARTIES_START = `${namespace}/FETCH_IMPARTIAL_PARTIES_START`;
export const FETCH_IMPARTIAL_PARTIES_SUCCESS = `${namespace}/FETCH_IMPARTIAL_PARTIES_SUCCESS`;
export const FETCH_IMPARTIAL_PARTIES_ERROR = `${namespace}/FETCH_IMPARTIAL_PARTIES_ERROR`;

export const fetchImpartialParties = makeApiActionCreatorV3(
  api.fetchImpartialParties,
  FETCH_IMPARTIAL_PARTIES_START,
  FETCH_IMPARTIAL_PARTIES_SUCCESS,
  FETCH_IMPARTIAL_PARTIES_ERROR,
);

export const FETCH_IMPARTIAL_PARTY_START = `${namespace}/FETCH_IMPARTIAL_PARTY_START`;
export const FETCH_IMPARTIAL_PARTY_SUCCESS = `${namespace}/FETCH_IMPARTIAL_PARTY_SUCCESS`;
export const FETCH_IMPARTIAL_PARTY_ERROR = `${namespace}/FETCH_IMPARTIAL_PARTY_ERROR`;

export const fetchImpartialParty = makeApiActionCreatorV3(
  api.fetchImpartialParty,
  FETCH_IMPARTIAL_PARTY_START,
  FETCH_IMPARTIAL_PARTY_SUCCESS,
  FETCH_IMPARTIAL_PARTY_ERROR,
);

export const INSERT_IMPARTIAL_PARTY_START = `${namespace}/INSERT_IMPARTIAL_PARTY_START`;
export const INSERT_IMPARTIAL_PARTY_SUCCESS = `${namespace}/INSERT_IMPARTIAL_PARTY_SUCCESS`;
export const INSERT_IMPARTIAL_PARTY_ERROR = `${namespace}/INSERT_IMPARTIAL_PARTY_ERROR`;

export const insertImpartialParty = makeApiActionCreatorV3(
  api.insertImpartialParty,
  INSERT_IMPARTIAL_PARTY_START,
  INSERT_IMPARTIAL_PARTY_SUCCESS,
  INSERT_IMPARTIAL_PARTY_ERROR,
);

export const UPDATE_IMPARTIAL_PARTY_START = `${namespace}/UPDATE_IMPARTIAL_PARTY_START`;
export const UPDATE_IMPARTIAL_PARTY_SUCCESS = `${namespace}/UPDATE_IMPARTIAL_PARTY_SUCCESS`;
export const UPDATE_IMPARTIAL_PARTY_ERROR = `${namespace}/UPDATE_IMPARTIAL_PARTY_ERROR`;

export const updateImpartialParty = makeApiActionCreatorV3(
  api.updateImpartialParty,
  UPDATE_IMPARTIAL_PARTY_START,
  UPDATE_IMPARTIAL_PARTY_SUCCESS,
  UPDATE_IMPARTIAL_PARTY_ERROR,
);

export const UPDATE_IMPARTIAL_PARTY_PHONE_START = `${namespace}/UPDATE_IMPARTIAL_PARTY_PHONE_START`;
export const UPDATE_IMPARTIAL_PARTY_PHONE_SUCCESS = `${namespace}/UPDATE_IMPARTIAL_PARTY_PHONE_SUCCESS`;
export const UPDATE_IMPARTIAL_PARTY_PHONE_ERROR = `${namespace}/UPDATE_IMPARTIAL_PARTY_PHONE_ERROR`;

export const updateImpartialPartyPhone = makeApiActionCreatorV3(
  api.updateImpartialPartyPhone,
  UPDATE_IMPARTIAL_PARTY_PHONE_START,
  UPDATE_IMPARTIAL_PARTY_PHONE_SUCCESS,
  UPDATE_IMPARTIAL_PARTY_PHONE_ERROR,
);

export const DELETE_IMPARTIAL_PARTY_START = `${namespace}/DELETE_IMPARTIAL_PARTY_START`;
export const DELETE_IMPARTIAL_PARTY_SUCCESS = `${namespace}/DELETE_IMPARTIAL_PARTY_SUCCESS`;
export const DELETE_IMPARTIAL_PARTY_ERROR = `${namespace}/DELETE_IMPARTIAL_PARTY_ERROR`;

export const deleteImpartialParty = makeApiActionCreatorV3(
  api.deleteImpartialParty,
  DELETE_IMPARTIAL_PARTY_START,
  DELETE_IMPARTIAL_PARTY_SUCCESS,
  DELETE_IMPARTIAL_PARTY_ERROR,
);

/* Impartial Party Association Actions */

export const FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_START = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_START`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_SUCCESS = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_SUCCESS`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_ERROR = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_ERROR`;

export const fetchImpartialPartyAssociations = makeApiActionCreatorV3(
  api.fetchImpartialPartyAssociations,
  FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_START,
  FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_SUCCESS,
  FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_ERROR,
);

export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_START = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_START`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_ERROR = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_ERROR`;

export const fetchImpartialPartyAssociation = makeApiActionCreatorV3(
  api.fetchImpartialPartyAssociation,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_START,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_ERROR,
);

export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_START = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_START`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_SUCCESS = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_SUCCESS`;
export const FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_ERROR = `${namespace}/FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_ERROR`;

export const fetchImpartialPartyAssociationFiles = makeApiActionCreatorV3(
  api.fetchImpartialPartyAssociationFiles,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_START,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_SUCCESS,
  FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_ERROR,
);

export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_START = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_START`;
export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS`;
export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_ERROR = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_ERROR`;

export const insertImpartialPartyAssociation = makeApiActionCreatorV3(
  api.insertImpartialPartyAssociation,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_START,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_ERROR,
);

export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_START = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_START`;
export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR`;

export const insertImpartialPartyAssociationFile = makeApiActionCreatorV3(
  api.insertImpartialPartyAssociationFile,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_START,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS,
  INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_START = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_START`;
export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS`;
export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_ERROR = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_ERROR`;

export const deleteImpartialPartyAssociation = makeApiActionCreatorV3(
  api.deleteImpartialPartyAssociation,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_START,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_ERROR,
);

export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_START = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_START`;
export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS`;
export const DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR = `${namespace}/DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR`;

export const deleteImpartialPartyAssociationFile = makeApiActionCreatorV3(
  api.deleteImpartialPartyAssociationFile,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_START,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS,
  DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_ERROR,
);

export const DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_START = `${namespace}/DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_START`;
export const DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_SUCCESS = `${namespace}/DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_SUCCESS`;
export const DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_ERROR = `${namespace}/DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_ERROR`;

export const downloadImpartialPartyFile = makeApiActionCreatorV3(
  api.downloadImpartialPartyFile,
  DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_START,
  DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_SUCCESS,
  DOWNLOAD_IMPARTIAL_ASSOCIATION_FILE_ERROR,
);

export const SET_IMPARTIAL_PARTY_PRIMARY_START = `${namespace}/SET_IMPARTIAL_PARTY_PRIMARY_START`;
export const SET_IMPARTIAL_PARTY_PRIMARY_SUCCESS = `${namespace}/SET_IMPARTIAL_PARTY_PRIMARY_SUCCESS`;
export const SET_IMPARTIAL_PARTY_PRIMARY_ERROR = `${namespace}/SET_IMPARTIAL_PARTY_PRIMARY_ERROR`;

export const setImpartialPartyPrimary = makeApiActionCreatorV3(
  api.setImpartialPartyPrimary,
  SET_IMPARTIAL_PARTY_PRIMARY_START,
  SET_IMPARTIAL_PARTY_PRIMARY_SUCCESS,
  SET_IMPARTIAL_PARTY_PRIMARY_ERROR,
);

export const CREATE_PORTAL_USER_START = `${namespace}/CREATE_PORTAL_USER_START`;
export const CREATE_PORTAL_USER_SUCCESS = `${namespace}/CREATE_PORTAL_USER_SUCCESS`;
export const CREATE_PORTAL_USER_ERROR = `${namespace}/CREATE_PORTAL_USER_ERROR`;

export const createPortalUser = makeApiActionCreatorV3(
  api.createPortalUser,
  CREATE_PORTAL_USER_START,
  CREATE_PORTAL_USER_SUCCESS,
  CREATE_PORTAL_USER_ERROR,
);

export const FETCH_CASE_APPRAISERS_START = `${namespace}/FETCH_CASE_APPRAISERS_START`;
export const FETCH_CASE_APPRAISERS_SUCCESS = `${namespace}/FETCH_CASE_APPRAISERS_SUCCESS`;
export const FETCH_CASE_APPRAISERS_ERROR = `${namespace}/FETCH_CASE_APPRAISERS_ERROR`;

export const fetchCaseAppraisers = makeApiActionCreatorV3(
  api.fetchCaseAppraisers,
  FETCH_CASE_APPRAISERS_START,
  FETCH_CASE_APPRAISERS_SUCCESS,
  FETCH_CASE_APPRAISERS_ERROR,
);

export const FETCH_CASE_APPRAISER_START = `${namespace}/FETCH_CASE_APPRAISER_START`;
export const FETCH_CASE_APPRAISER_SUCCESS = `${namespace}/FETCH_CASE_APPRAISER_SUCCESS`;
export const FETCH_CASE_APPRAISER_ERROR = `${namespace}/FETCH_CASE_APPRAISER_ERROR`;

export const fetchCaseAppraiser = makeApiActionCreatorV3(
  api.fetchCaseAppraiser,
  FETCH_CASE_APPRAISER_START,
  FETCH_CASE_APPRAISER_SUCCESS,
  FETCH_CASE_APPRAISER_ERROR,
);

export const INSERT_CASE_APPRAISER_START = `${namespace}/INSERT_CASE_APPRAISER_START`;
export const INSERT_CASE_APPRAISER_SUCCESS = `${namespace}/INSERT_CASE_APPRAISER_SUCCESS`;
export const INSERT_CASE_APPRAISER_ERROR = `${namespace}/INSERT_CASE_APPRAISER_ERROR`;

export const insertCaseAppraiser = makeApiActionCreatorV3(
  api.insertCaseAppraiser,
  INSERT_CASE_APPRAISER_START,
  INSERT_CASE_APPRAISER_SUCCESS,
  INSERT_CASE_APPRAISER_ERROR,
);

export const UPDATE_CASE_APPRAISER_START = `${namespace}/UPDATE_CASE_APPRAISER_START`;
export const UPDATE_CASE_APPRAISER_SUCCESS = `${namespace}/UPDATE_CASE_APPRAISER_SUCCESS`;
export const UPDATE_CASE_APPRAISER_ERROR = `${namespace}/UPDATE_CASE_APPRAISER_ERROR`;

export const updateCaseAppraiser = makeApiActionCreatorV3(
  api.updateCaseAppraiser,
  UPDATE_CASE_APPRAISER_START,
  UPDATE_CASE_APPRAISER_SUCCESS,
  UPDATE_CASE_APPRAISER_ERROR,
);

export const DELETE_CASE_APPRAISER_START = `${namespace}/DELETE_CASE_APPRAISER_START`;
export const DELETE_CASE_APPRAISER_SUCCESS = `${namespace}/DELETE_CASE_APPRAISER_SUCCESS`;
export const DELETE_CASE_APPRAISER_ERROR = `${namespace}/DELETE_CASE_APPRAISER_ERROR`;

export const deleteCaseAppraiser = makeApiActionCreatorV3(
  api.deleteCaseAppraiser,
  DELETE_CASE_APPRAISER_START,
  DELETE_CASE_APPRAISER_SUCCESS,
  DELETE_CASE_APPRAISER_ERROR,
);
